var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOrganisationBilling(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3 19H4V6.36001C4.00003 6.04515 4.09914 5.73828 4.28328 5.48289C4.46743 5.22749 4.72727 5.03651 5.026 4.93701L13.026 2.27101C13.2515 2.19592 13.4915 2.17547 13.7264 2.21134C13.9614 2.24722 14.1844 2.33839 14.3772 2.47735C14.5699 2.61632 14.7269 2.79909 14.8352 3.01062C14.9435 3.22215 15 3.45638 15 3.69401V19H16V9.99001C16 9.91607 16.0165 9.84305 16.0482 9.77623C16.0798 9.7094 16.1259 9.65043 16.1831 9.60357C16.2403 9.5567 16.3072 9.5231 16.3789 9.5052C16.4507 9.48729 16.5255 9.48552 16.598 9.50001L18.794 9.94001C19.1339 10.008 19.4398 10.1915 19.6597 10.4595C19.8795 10.7275 19.9998 11.0634 20 11.41V19H21C21.2652 19 21.5196 19.1054 21.7071 19.2929C21.8946 19.4804 22 19.7348 22 20C22 20.2652 21.8946 20.5196 21.7071 20.7071C21.5196 20.8947 21.2652 21 21 21H3C2.73478 21 2.48043 20.8947 2.29289 20.7071C2.10536 20.5196 2 20.2652 2 20C2 19.7348 2.10536 19.4804 2.29289 19.2929C2.48043 19.1054 2.73478 19 3 19Z",
    fill: "#667085"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrganisationBilling);
export default __webpack_public_path__ + "static/media/OrganisationBilling.98a6979604577eccb911a45e9caa652b.svg";
export { ForwardRef as ReactComponent };